import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Stat, Title, Value } from './styles';
export const Stats = ({ stats }) => (_jsx(Container, { children: stats.map((s, index, array) => (_jsxs(Stat, { "$index": index, "$total": array.length, children: [_jsx(Title, { children: s.title.toUpperCase() }), _jsx(Value, { children: s.value })] }, s.id))) }));
